import { getId } from '@/utils/temporaryHelper'

export const InitialColorIds = {
  default: getId(),
  header: getId(),
  footer: getId(),
  tag1: getId(),
  tag2: getId(),
  dusk: getId(),
  cloudy: getId(),
  magenta: getId(),
  pear: getId(),
}
